import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconTrial: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconTrial"><Path d="M11.9422 21C29.7041 11.0575 18.486 -1.25346 11.9422 5.37552C6.01583 -0.627847 -3.69994 9.5 7.99993 18" stroke="currentColor"/><Path d="M4.5 18.5H8.5V14.5" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconTrial;
